// src/pages/Groomers.js
import React, { useReducer, useEffect } from "react";
import {
  Table,
  TableHead,
  TableBody,
  Paper,
  Typography,
  CircularProgress,
  Toolbar as MuiToolbar,
} from "@mui/material";
import GroomerRow from "./GroomerRow";
import Pagination from '../components/Pagination';
import GroomersTableHead from "../components/GroomersTableHead";
import { initialState, groomersReducer } from "../reducers/groomersReducer";
import { handleSortRequest } from "../utils/sortingUtils";
import { ACTIONS } from '../reducers/listActions';
import api from "../services/api";

const columns = [
  { id: "redirect", label: "", sortable: false },
  { id: "firstName", label: "First Name", sortable: true },
  { id: "lastName", label: "Last Name", sortable: true },
  { id: "address", label: "Address", sortable: false },
  { id: "phone1", label: "Phone 1", sortable: true },
  { id: "phone2", label: "Phone 2", sortable: true },
  { id: "email", label: "Email", sortable: false },
  { id: "active", label: "Status", sortable: true },
  { id: "comments", label: "", sortable: false },
  { id: "imageUrl", label: "", sortable: false },
];

function Groomers({ data }) {
  const [state, dispatch] = useReducer(groomersReducer, initialState);
  const {
    groomers = [],
    loading,
    error,
    order,
    orderBy,
    page,
    rowsPerPage,
    totalGroomers,
  } = state;

  const isSearchMode = !!data;
  const displayedGroomers = isSearchMode ? data : groomers;

  useEffect(() => {
    if (isSearchMode) return;

    const fetchGroomers = async () => {
      dispatch({ type: ACTIONS.FETCH_INIT });
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          throw new Error("No token found");
        }
        const response = await api.get("/groomers", {
          headers: { Authorization: `Bearer ${token}` },
          params: { page: page + 1, limit: rowsPerPage, sortBy: orderBy, order: order },
        });
        dispatch({ type: ACTIONS.FETCH_SUCCESS, payload: { groomers: response.data.data, total: response.data.total } });
      } catch (err) {
        console.error("Error fetching groomers:", err);
        dispatch({ type: ACTIONS.FETCH_FAILURE, payload: "Failed to fetch groomers." });
      }
    };

    fetchGroomers();
  }, [page, rowsPerPage, order, orderBy, isSearchMode]);

  const handleSort = handleSortRequest(orderBy, order, dispatch);

  const handleChangePage = (event, newPage) => {
    dispatch({ type: ACTIONS.SET_PAGE, payload: newPage });
  };

  const handleChangeRowsPerPage = (event) => {
    dispatch({
      type: ACTIONS.SET_ROWS_PER_PAGE,
      payload: parseInt(event.target.value, 10),
    });
  };

  return (
    <>
      <MuiToolbar />
      <Paper sx={{ padding: "1rem", width: "97%", margin: "1rem auto" }}>
        <Typography variant="h4" gutterBottom>
          Groomers
        </Typography>
        {loading ? (
          <div style={{ textAlign: "center", marginTop: "2rem" }}>
            <CircularProgress />
          </div>
        ) : error ? (
          <Typography variant="h6" color="error" align="center">
            {error}
          </Typography>
        ) : displayedGroomers.length === 0 ? (
          <Typography>No groomers found.</Typography>
        ) : (
          <>
            {!isSearchMode && (
              <Pagination
                count={totalGroomers}
                page={page}
                rowsPerPage={rowsPerPage}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            )}
            <Table>
              <TableHead>
                <GroomersTableHead
                  columns={columns}
                  order={order}
                  orderBy={orderBy}
                  onSortRequest={handleSort}
                />
              </TableHead>
              <TableBody>{displayedGroomers.map((groomer) => <GroomerRow key={groomer.id} groomer={groomer} groomers={displayedGroomers} />)}</TableBody>
            </Table>
            {!isSearchMode && (
              <Pagination
                count={totalGroomers}
                page={page}
                rowsPerPage={rowsPerPage}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            )}
          </>
        )}
      </Paper>
    </>
  );
}

export default Groomers;